import { AdvertisementLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Forms = [
  {
    fileStoreId: "4f1665d2-eb4c-45f7-93d5-81ce2f775ac8",
    label: "Application Form for Empanelment of Advertising Agencies",
  },
  {
    fileStoreId: "7e7dfb45-5f8e-45bb-b1f4-07360590146e",
    label: "Form for Application for Erection of Hoarding",
  },
  {
    fileStoreId: "8da9afd4-cc45-4c37-8362-3af1c175752d",
    label: "Sample Affidavit Format",
  },
];

const Advertisement_download_forms = () => (
  <TableStructure
    title="Download Forms"
    heading={"Forms List"}
    list={Forms}
    leftMenuList={AdvertisementLeftMenuList}
    longMenuList={true}
  />
);

export default Advertisement_download_forms;
